module.exports = __webpack_public_path__ + "img/fi-rr-rectangle-panoramic.f7ad8eb3.svg";